'use client';

import { useNuqsNextAppRouterAdapter } from '../../chunk-ZDI47QWR.js';
import '../../chunk-BWA4ZRHH.js';
import '../../chunk-3RCMAOX7.js';
import { createAdapterProvider } from '../../chunk-X3EUQ3RW.js';

// src/adapters/next/app.ts
var NuqsAdapter = createAdapterProvider(useNuqsNextAppRouterAdapter);

export { NuqsAdapter };
